import { NgModule } from '@angular/core';
import { LabelControlDirective } from './formLabel';

@NgModule({
    imports: [],
    declarations: [LabelControlDirective],
    exports: [LabelControlDirective]
})

export class DirectiveModule { }